module.exports = __webpack_public_path__ + "static/media/appstore-6c.760c70e2.png";